import styled from 'styled-components';
import {
  spacing,
  colors,
  body2,
  overline,
  heading3,
  caption,
  subtitle1,
  subtitle2,
  heading5,
  borderRadius,
} from 'ui/theme';
import { Divider } from 'ui/divider';
import { BrandAffinityLevel, BRAND_AFFINITY_COLORS } from 'modules/domains';

export const StyledAffinityUsersWrapper = styled.div`
  display: flex;
  margin: ${spacing.plusHalf};
  justify-content: space-between;
  align-items: center;
`;

export const StyledSecondaryBodyText = styled.div`
  ${body2};
  color: ${colors.textSecondary};
`;

export const StyledPrimaryBodyText = styled.div`
  ${body2};
  color: ${colors.textPrimary};
`;

export const StyledCaptionPrimary = styled.div`
  ${caption}
  color:${colors.textPrimary}
`;

export const StyledCaptionSecondary = styled.div`
  ${caption}
  color:${colors.textSecondary}
`;

export const StyledOverline = styled.div`
  ${overline};
  color: ${colors.textSecondary};
  padding-bottom: ${spacing.base};
`;

export const StyledEngagementOverline = styled(StyledOverline)`
  padding-bottom: ${spacing.plusHalf};
`;

export const StyledHeading = styled.div`
  ${heading3}
  color: ${colors.textPrimary};
`;

export const StyledSmallDivider = styled(Divider)`
  margin-top: ${spacing.base};
  margin-bottom: ${spacing.base};
  width: 100%;
`;

export const StyledDivider = styled(Divider)`
  margin: 0 ${spacing.plusHalf} 0 ${spacing.plusHalf};
`;

export const StyledCountDivider = styled(Divider)`
  width: 100%;
`;

export const StyledAffinityContentHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledAffinityCardsWrapper = styled.div`
  padding: 0 ${spacing.plusHalf} 0 ${spacing.plusHalf};
  display: flex;
  gap: ${spacing.base};
  justify-content: space-between;
`;

export const AffinityCardsFlexResponsiveContainer = styled(StyledAffinityCardsWrapper)`
  @media screen and (width <= 1280px) {
    flex-direction: column;
  }
`;

export const StyledCampaignCardsWrapper = styled.div`
  padding: 0 ${spacing.plusHalf} ${spacing.plusHalf} ${spacing.plusHalf};
  display: flex;
  gap: ${spacing.base};
  justify-content: space-between;
`;

export const StyledOverlineCard = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: ${spacing.half};
  background-color: ${colors.backgroundSecondary};
  padding: ${spacing.plusHalf};
`;

export const StyledEngagementCard = styled(StyledOverlineCard)`
  flex: 0 0 40%;
`;

export const StyledUserMovementCard = styled(StyledOverlineCard)`
  width: 100%;
`;

export const StyledSubtitle = styled.div`
  ${subtitle1}
`;

export const StyledSubtitleHeader = styled(StyledSubtitle)`
  padding: ${spacing.plusHalf} ${spacing.plusHalf} ${spacing.base} ${spacing.plusHalf};
`;

export const StyledOverviewMetrics = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-evenly;
`;

export const StyledMetricRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledMetric = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.quarter};
`;

export const StyledMetricCount = styled.div`
  ${heading5}
`;

export const StyledMovementLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${spacing.threeQuarter};
  padding-top: ${spacing.threeQuarter};
`;
export const StyledCircleLegend = styled.div`
  border-radius: 100%;
  width: ${spacing.threeQuarter};
  height: ${spacing.threeQuarter};

  &[data-cohort='loyal'] {
    background-color: ${BRAND_AFFINITY_COLORS[BrandAffinityLevel.LOYAL]};
  }
  &[data-cohort='positive'] {
    background-color: ${BRAND_AFFINITY_COLORS[BrandAffinityLevel.POSITIVE]};
  }

  &[data-cohort='neutral'] {
    background-color: ${BRAND_AFFINITY_COLORS[BrandAffinityLevel.NEUTRAL]};
  }

  &[data-cohort='negative'] {
    background-color: ${BRAND_AFFINITY_COLORS[BrandAffinityLevel.NEGATIVE]};
  }

  &[data-cohort='unscored'] {
    background-color: ${BRAND_AFFINITY_COLORS[BrandAffinityLevel.UNSCORED]};
  }

  &[data-cohort='new'] {
    background-color: ${colors.grey15};
  }

  &[data-cohort='deleted'] {
    background-color: ${colors.grey80};
  }
`;

export const StyledLegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;

export const StyledContributionSection = styled.div`
  padding: 0 ${spacing.plusHalf} ${spacing.plusHalf} ${spacing.plusHalf};
`;

export const StyledContributionsCardsWrapper = styled(StyledOverlineCard)`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
`;

export const ContributionCardsFlexResponsiveContainer = styled(StyledContributionsCardsWrapper)`
  @media screen and (width <= 1280px) {
    flex-direction: column;
    gap: ${spacing.double};
    width: 100%;
  }
`;

export const StyledUnscoredContributionsCardsWrapper = styled(StyledOverlineCard)`
  display: flex;
  gap: ${spacing.doubleHalf};
  padding: 0;
  flex-direction: row;
  background-color: ${colors.white};
`;

export const StyledContributionsCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};
  padding-right: ${spacing.doubleHalf};
  flex: 11;
  height:100%;
`;

export const StyledContributionsByChannelsCard = styled(StyledOverlineCard)`
  background-color: ${colors.backgroundTertiary};
  border-radius: ${borderRadius.lg};
  padding: ${spacing.base} ${spacing.base} 0 ${spacing.base};
  width: 100%;
  flex: 9;
  height:100%;
`;

export const StyledSubtitlePrimary = styled.div`
  ${subtitle2}
  color:${colors.textPrimary}
`;

export const StyledCampaignHeaderWithSelectDropdown = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
